"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createActionColumn = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const uuid_1 = require("@lukeed/uuid");
function addCustomColumn(array, options) {
    const { index, Header = () => null, accessor = null, Cell = null, sortType = 'basic', enableRowSpan = false, style = {}, id, } = options || {};
    array.push({
        index,
        ...(id && { id }),
        ...(accessor && { accessor }),
        ...(Cell && { Cell }),
        Header,
        sortType,
        enableRowSpan,
        style,
    });
}
exports.default = addCustomColumn;
function createActionColumn(options) {
    const { onClick, icon, index, style = {} } = options;
    return {
        index,
        Header: '',
        style: {
            width: '1%',
            maxWidth: '20px',
            minWidth: '20px',
            padding: '0px',
            textAlign: 'center',
            ...style,
        },
        id: (0, uuid_1.v4)(),
        Cell: ({ row }) => ((0, jsx_runtime_1.jsx)("button", { type: "button", onClick: (e) => {
                e.preventDefault();
                e.stopPropagation();
                onClick(row, e);
            }, children: icon })),
    };
}
exports.createActionColumn = createActionColumn;
